@if ((policy$ | async); as policy) {
  <section>
    <span [innerHtml]="policy.data.attributes.text"></span>
  </section>
}